import { Box, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

interface IconLabelProps {
  label: string;
  icon: string;
  iconColor?: string;
  variant?: 'caption' | 'body2';
  size?: number;
  fontSize?: number;
  labelColor?: string;
}

export function IconLabel({
  label,
  icon,
  iconColor = 'text.secondary',
  variant = 'caption',
  size = 16,
  fontSize = 12,
  labelColor = 'text.secondary',
}: IconLabelProps) {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Iconify icon={icon} color={iconColor} width={size} height={size} />
      <Typography variant={variant} fontSize={fontSize} color={labelColor}>
        {label}
      </Typography>
    </Box>
  );
}
